function calcProgressBar() {

  const scrollTop = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0)
  const scrollHeight = (document.documentElement.scrollHeight - window.innerHeight)

  this.value = scrollTop / scrollHeight

  window.requestAnimationFrame(this.calcProgressBar)

}

let ProgressBar = Vue.component('progress-bar', {
  props: ['color'],
  data: function() {
		return {
			value: 0
		}
	},
	methods: {
		calcProgressBar: calcProgressBar
	},
	computed: {
    style() {
      return {
        backgroundColor: this.color,
        transform: `scaleX(${ this.value })`
      }
    }
	},
  mounted() {
    window.requestAnimationFrame(this.calcProgressBar)
	},
	template: `
		<div class="progress-bar">
			<div class="progress" :style="this.style"></div>
		</div>`
})

export default ProgressBar
